import {input, button, modal} from './tokens/semantic/radii'

const borderRadius = {
    radii: {
        borderRadius: {
            input,
            button,
            modal,
        },
    },
}

export default borderRadius
